<mat-dialog-content [class]="contentClass()">
  @if (data.title || data.headerIcon) {
  <h3 class="dialog-title" [class.dialog-title--with-icon]="data.headerIcon">
    @if (data.headerIcon) {
    <mat-icon [class]="data.headerIconClass">{{ data.headerIcon }}</mat-icon>
    }
    <span class="dialog-title__text">{{ data.title }}</span>
    @if (data.headerDate) {
    <span class="dialog-title__date">{{ data.headerDate }}</span>
    }
  </h3>
  }

  @if (isCompactSingleTab() || isSingleTabHeaderHidden()) {
  <div class="dialog-tab-body">
    <ng-container [appTabHost]="data.tabs[0].name"></ng-container>
  </div>
  } @else {
  <mat-tab-group (selectedIndexChange)="onTabChange($event)" [class.dialog-tabs--compact]="data.variant === 'compact'">
    @for(tab of data.tabs; track tab.name) {
    <mat-tab [label]="tab.name">
      <!-- Removed ng-template matTabContent to persist state across tabs -->
      <div class="dialog-tab-body">
        <!-- Using the directive name as property binder to simplify and break cycles -->
        <ng-container [appTabHost]="tab.name"></ng-container>
      </div>
    </mat-tab>
    }
  </mat-tab-group>
  }
</mat-dialog-content>

@if (hasActions()) {
<mat-dialog-actions align="start">
  @let currActions = currentActions();
  @if (currActions.showClose) {
  <button mat-stroked-button type="button" [disabled]="saving()" (click)="onCloseAction()">
    {{ currActions.closeLabel }}
  </button>
  }
  @if (currActions.showSaveAndContinue) {
  <button mat-flat-button type="button" class="dialog-action--success" data-testid="save-and-continue-btn"
    [disabled]="saving() || !canSave()" (click)="onSaveAndContinueAction()">
    {{ currActions.saveAndContinueLabel }}
  </button>
  }
  @if (currActions.showSave) {
  <button mat-flat-button color="primary" type="button" data-testid="save-btn" [disabled]="saving() || !canSave()"
    (click)="onSaveAction()">
    {{ currActions.saveLabel }}
  </button>
  }
</mat-dialog-actions>
}
